import _export from '../internals/export.js';
import stringPad from '../internals/string-pad.js';
import stringPadWebkitBug from '../internals/string-pad-webkit-bug.js';

var $ = _export;
var $padStart = stringPad.start;
var WEBKIT_BUG = stringPadWebkitBug; // `String.prototype.padStart` method
// https://tc39.es/ecma262/#sec-string.prototype.padstart

$({
  target: 'String',
  proto: true,
  forced: WEBKIT_BUG
}, {
  padStart: function padStart(maxLength
  /* , fillString = ' ' */
  ) {
    return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
  }
});
